<template lang="pug">
  v-card.rounded-lg.elevation-4(style="overflow:hidden")
    v-card-text.pa-0(style="position:relative;")
      v-img(:src="imagen" :aspect-ratio="16/9" height="200" style="margin:10px;").rounded-lg
      v-btn(style="position:absolute;top:15px;right:0px;padding:8px 10px 8px 10px;height:auto;border-radius:6px 0px 0px 6px" color="orange darken-1" dark).txtn
        | Descargar&nbsp;
        v-icon(size="16") fas fa-download
    v-card-text.pa-6.pb-0
      v-card(style="margin-top:-74px;" flat).rounded-lg.rounded-bl-0.rounded-br-0
        v-card-actions.pa-2
          v-chip(color="blue darken-2" small dark label) Destacado
          v-spacer
          h5.red--text.text--darken-2 {{ fecha }}
    v-card-text.pa-5.mt-3
      v-card(flat style="margin-top:-50px;")
        v-card-text.pa-0
          h6.subtitle-1.blue--text.text--darken-2(style="text-align:justify;line-height:22px").font-weight-medium {{ titulo }}
        v-card-text.pa-0.mt-1
          p(style="text-align:justify").pt-0.mb-0 {{ description }}
    //-v-card-actions
      v-spacer
      v-btn(dark color="orange darken-2").txtn
        | Descargar&nbsp;
        v-icon(size="16") fas fa-download
</template>

<script>
export default {
  data: () => ({
    rotator: 0
  }),
  props: {
    reverse: Boolean,
    imagen: String,
    titulo: String,
    fecha: String,
    description: String,
  }
}
</script>
